import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpRequest, HttpHandler,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { JWTService } from '../services/jwt.service';
import { environment } from 'src/environments/environment';
import { SnackbarStatusType } from 'src/app/shared/enum/snackbarStatusType.enum';
import { ProgressBarService } from '../services/progress-bar.service';
import { SnackbarService } from '../../shared/services/snackbar.service';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
/** This ServerErrorInterceptor class intercepts HTTP requests and handles server errors, displays
appropriate error messages and hides all spinner and loading components. */
export class ServerErrorInterceptor implements HttpInterceptor {
    constructor(
      private _authService: AuthService,
      private _jwtService: JWTService,
      private _snackbarService: SnackbarService,
      private _progressBarService: ProgressBarService,
      private _spinnerService: SpinnerService,
    ) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(
        catchError((response: HttpErrorResponse) => {
          // console.log(response);
          if ([403, 401].includes(response.status) && this._authService.getLoginStatus()) {
            // force logout if 403 response returned from api
            this._jwtService.checkRefreshExpiration();
            //this._authService.logout();
          } else if ([500].includes(response.status) && this._authService.getLoginStatus() && !environment.production) {
            if(response.error.error.message) {
              this._snackbarService.openSnackBar(response.error.error.message, 'OK', SnackbarStatusType.error);
            }
            else if (response.error.error.description) {
              this._snackbarService.openSnackBar(response.error.error.description, 'OK', SnackbarStatusType.error);
            }
          } else if ([400].includes(response.status) && this._authService.getLoginStatus()) {
            //TODO: Dynamic error type detection!!!
            if(response.error.error.type === 'USER_ALREADY_EXISTS_EMAIL') {
              this._snackbarService.openSnackBar('User existiert bereits mit der E-Mail.', 'OK', SnackbarStatusType.warn);
            }
            else if(response.error.error.type === 'USER_ALREADY_EXISTS_USERNAME') {
              this._snackbarService.openSnackBar('User existiert bereits mit dem Usernamen.', 'OK', SnackbarStatusType.warn);
            }
            else if(response.error.error.type === 'COMPANY_ALREADY_EXISTS_USERNAME') {
              this._snackbarService.openSnackBar('Firma existiert bereits mit dem Firmennamen.', 'OK', SnackbarStatusType.warn);
            }
          }else {
            this._snackbarService.openSnackBar('Unknown error.', 'OK', SnackbarStatusType.error);
          }
          return throwError(() => {
            this._progressBarService.hide();
            this._spinnerService.hide();
            return response;
          });
        })
      );
    }
}
